export default __webpack_public_path__ + "static/media/pencil.c57a7d18.webp";